<div [class]="containerClasses">
    @if (imageSrc) {
    <img [src]="imageSrc" [alt]="altText || 'Image'" [class]="imageClasses" (error)="onImageError()"
        (load)="onImageLoad()" />
    } @else {
    <div [class]="placeholderClasses">
        @if (showPlaceholderIcon) {
        <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        }
        @if (placeholderText) {
        <span class="text-sm text-gray-500 mt-2">{{ placeholderText }}</span>
        }
    </div>
    }

    @if (overlay) {
    <div [class]="overlayClasses">
        <ng-content select="[slot=overlay]"></ng-content>
    </div>
    }
</div>